export enum DeliveryNoteStatus {
  Pending = 'pending',
  Received = 'received',
  Invoiced = 'invoiced',
  Cancelled = 'cancelled',
}
